import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Select,
  Checkbox,
  Button,
  Input,
  Form,
  Collapse,
  Card,
  InputNumber
} from 'antd';
import styles from './styles.module.less';
import { UserOutlined } from '@ant-design/icons';
import { MdOutlineWorkOutline } from 'react-icons/md';
import { FaGraduationCap, FaMoneyCheckAlt } from 'react-icons/fa';
import { IoLocationOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import HeartIcon from '@/common/assets/images/fullHeart.svg';
import HeartOut from '@/common/assets/images/heart.svg';
import searchwhite from '@/common/assets/images/searchwhite.svg';
import { useDispatch } from 'react-redux';

const { Panel } = Collapse;
const { Option } = Select;

const SlideBar = ({
  searchData,
  city_details,
  country_codes,
  state_details,
  education_list,
  department_details,
  get_searchResult,
  onProfileAction,
  onSubmit,
  searchResult_loading
  // handleRequestAction
}) => {
  const [visible, setVisible] = useState(true);
  const [likedProfiles, setLikedProfiles] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [minAge, setMinAge] = useState(18);
  const [minHeight, setMinHeight] = useState(100);
  // console.log('isHovered', isHovered);
  const list_data = searchData;
  console.log('searchData', searchData);

  // const transformedData = list_data?.flatMap((item) => {
  //   return item.Profiles.map((profile) => ({
  //     pic:
  //       profile?.ProfileImages?.length > 0
  //         ? profile?.ProfileImages?.[0]?.objectKey
  //         : '',
  //     code: item?.profile_unique_id || '',
  //     name: profile?.profile_name || '',
  //     dob: profile?.calculated_age ? `${profile?.calculated_age} ` : '',
  //     // height: `${profile?.height_ft || ''}' ${profile.height_in || ''}"`,
  //     height: profile?.height_cms ? `${profile.height_cms} cm` : '',
  //     marriedStatus: profile?.MaritalStatus?.marital_status,
  //     address: profile?.City?.city || '',
  //     occupation: profile?.employed_in || '',
  //     education:
  //       profile.ProfileEducations.map(
  //         (edu) => edu?.HigherEducation?.higher_education
  //       ).join(', ') || '',
  //     // income: profile.annual_income || '',
  //     income: profile.annual_income
  //       ? Number(profile.annual_income).toLocaleString()
  //       : '',
  //     isNew: item?.is_new,
  //     isFavourite: profile.is_favourite,
  //     id: item.id,
  //     profile_id: profile.id
  //   }));
  // });
  const transformedData = React.useMemo(() => {
    return (
      list_data?.flatMap((item) => {
        return item.Profiles.map((profile) => ({
          pic:
            profile?.ProfileImages?.length > 0
              ? profile?.ProfileImages?.[0]?.objectKey
              : '',
          code: item?.profile_unique_id || '',
          name: profile?.profile_name || '',
          dob: profile?.calculated_age ? `${profile?.calculated_age} ` : '',
          height: profile?.height_cms ? `${profile.height_cms} cm` : '',
          marriedStatus: profile?.MaritalStatus?.marital_status,
          address: profile?.City?.city || '',
          occupation: profile?.employed_in || '',
          education:
            profile.ProfileEducations.map(
              (edu) => edu?.HigherEducation?.higher_education
            ).join(', ') || '',
          income: profile.annual_income
            ? Number(profile.annual_income).toLocaleString()
            : '',
          isNew: item?.is_new,
          isFavourite: profile.is_favourite,
          id: item.id,
          profile_id: profile.id,
          is_shortlisted: profile.is_shortlisted,
          is_req_accepted: profile.is_req_accepted,
          is_req_rejected: profile.is_req_rejected,
          is_requsted: profile.is_requsted,
          is_request_received: profile.is_request_received
        }));
      }) || []
    );
  }, [list_data]);

  const isVisible = () => {
    setVisible((prev) => !prev);
  };

  const handleShortList = (profileId) => {
    // console.log('handleShortList');
    onSubmit({ profile_id: profileId, action: 'short_profile' });
  };

  // const handleSendRequest = (profileId) => {
  //   // console.log('handleSendRequest');
  //   onSubmit({ profile_id: profileId, action: 'send_request' });
  // };

  console.log('transformedData', transformedData);

  const handleViewProfile = (id) => {
    console.log('Calling view API with ID:', id);
    navigate(`/profileview/${id}`);
  };

  const handleLikeClick = (e, profileId, sourceType) => {
    e.stopPropagation();
    setLikedProfiles((prev) => ({
      ...prev,
      [profileId]: !prev[profileId]
    }));
    onProfileAction(
      profileId,
      !likedProfiles[profileId] ? 'like' : 'unlike',
      sourceType
    );
  };

  const onSearch = async () => {
    try {
      const values = await form.validateFields();

      const maritalStatus = values.maritalStatus || [];
      const familyType = values.familyType || [];
      const familyStatus = values.familyStatus || [];
      const familyValues = values.familyValues || [];
      const employeeIn = values.employeeIn || [];

      const formData = {
        min_height_cm: values.minHeight || '',
        max_height_cm: values.maxHeight || '',
        min_age: values.minAge || '',
        max_age: values.maxAge || '',
        marital_status: maritalStatus,
        family_type: familyType,
        city: values.city || '',
        state: values.state || '',
        country: values.country || '',
        parent_mother_education: values.desired_partner_mother_education || '',
        parent_father_education: values.desired_partner_father_education || '',
        family_status: familyStatus,
        family_values: familyValues,
        // education: values.education,
        higher_education: values.education || '',
        employed_in: employeeIn,
        department: values.department,
        // income: values.income
        min_income: values.min_income || '',
        max_income: values.max_income || ''
      };

      localStorage.setItem('formData', JSON.stringify(formData));

      console.log('Stored Data:', formData);

      const payload = { ...formData };

      const response = await dispatch(get_searchResult(payload));
      if (response?.payload?.success) {
        navigate('/searchresult', { state: { data: response.payload.data } });
      } else {
        console.error('API call failed:', response.payload.message);
      }
    } catch (error) {
      console.error('Error fetching search result:', error);
    }
  };

  useEffect(() => {
    const storedPayload =
      JSON.parse(localStorage.getItem('search_result')) || {};
    const existingValues = form.getFieldsValue();
    const mergeArray = (existing, stored) => {
      const flatStored = stored
        ? Array.isArray(stored)
          ? stored.flat()
          : [stored]
        : [];
      const flatExisting = existing
        ? Array.isArray(existing)
          ? existing.flat()
          : [existing]
        : [];
      return [...new Set([...flatExisting, ...flatStored])];
    };

    // console.log(
    //   'familyValues',
    //   mergeArray(existingValues.familyValues, storedPayload?.family_values_id)
    // );

    console.log('min_income', storedPayload?.min_income);

    const updatedValues = {
      ...existingValues,
      maxAge: storedPayload?.max_age || existingValues.maxAge,
      minAge: storedPayload?.min_age || existingValues.minAge,
      minHeight: storedPayload?.min_height_cm || existingValues.minHeight,
      maxHeight: storedPayload?.max_height_cm || existingValues.maxHeight,
      max_income: storedPayload?.max_income || existingValues.max_income,
      min_income: storedPayload?.min_income || existingValues.min_income,
      maritalStatus: mergeArray(
        existingValues.maritalStatus,
        storedPayload?.marital_status
      ),
      city: mergeArray(existingValues.city, storedPayload?.city),
      state: storedPayload?.state || existingValues.state,
      country: storedPayload?.country || existingValues.country,
      education: storedPayload?.higher_education || existingValues.education,
      employeeIn: mergeArray(
        existingValues.employeeIn,
        storedPayload?.employed_in
      ),
      familyType: mergeArray(
        existingValues.familyType,
        storedPayload?.family_type
      ),
      familyStatus: mergeArray(
        existingValues.familyStatus,
        storedPayload?.family_status
      ),
      familyValues: mergeArray(
        existingValues.familyValues,
        storedPayload?.family_values
      ),
      department: storedPayload?.department || existingValues.department,
      income: storedPayload?.annual_income || existingValues.income,
      desired_partner_mother_education:
        storedPayload?.parent_mother_education ||
        existingValues.desired_partner_mother_education,
      desired_partner_father_education:
        storedPayload?.parent_father_education ||
        existingValues.desired_partner_father_education
    };

    form.setFieldsValue(updatedValues);
  }, [form]);

  const handle_removeLocalStorage = () => {
    // localStorage.removeItem('search_result');
    form.resetFields();
  };

  const handle_backButton = () => {
    navigate('/search');
  };

  // useEffect(() => {
  //   if (transformedData?.length) {
  //     const initialLikedState = {};
  //     transformedData.forEach((profile) => {
  //       initialLikedState[profile.profile_id] = profile.isFavourite;
  //     });
  //     setLikedProfiles(initialLikedState);
  //   }
  // }, [transformedData]);

  useEffect(() => {
    if (transformedData?.length) {
      // Only update the state if there's a difference
      setLikedProfiles((prevState) => {
        const initialLikedState = {};
        let hasChanges = false;

        transformedData.forEach((profile) => {
          initialLikedState[profile.profile_id] = profile.isFavourite;
          if (prevState?.[profile.profile_id] !== profile.isFavourite) {
            hasChanges = true;
          }
        });

        // Only return a new state if there are actual changes
        return hasChanges ? initialLikedState : prevState;
      });
    }
  }, [transformedData]);

  return (
    <>
      <div className={styles.mainContainer}>
        <div
          className={styles.container}
          // style={{ width: visible ? '23%' : '5% ' }}
        >
          <Form form={form} layout="vertical" style={{ height: '100vh' }}>
            <Row className={styles.slideOuter}>
              <span
                className={styles.arrow}
                onClick={isVisible}
                style={
                  visible
                    ? {}
                    : {
                        position: 'absolute',
                        left: '53px',
                        top: '236px',
                        padding: '10px',
                        marginRight: '10px',
                        fontSize: '30px'
                      }
                }
              ></span>
              {visible && (
                <Col span={24} className={styles.slider}>
                  <div className={styles.dflex}>
                    <span className={styles.header}>Search Filter</span>
                    {/* <Button
                      type="primary"
                      onClick={onSearch}
                      className={styles.btnsubmit}
                      loading={searchResult_loading}
                    >
                      <img
                        src={searchwhite}
                        alt="Search Icon"
                        className={styles.searchIcon}
                      />{' '}
                      Search
                    </Button> */}
                    <Button
                      type="primary"
                      onClick={onSearch}
                      className={styles.btnsubmit}
                      loading={searchResult_loading} // shows Ant Design spinner
                    >
                      {/* Only show image if not loading */}
                      {!searchResult_loading && (
                        <img
                          src={searchwhite}
                          alt="Search Icon"
                          className={styles.searchIcon}
                        />
                      )}
                      Search
                    </Button>
                  </div>

                  {/* About Me Section */}
                  <Collapse
                    accordion
                    expandIconPosition={'end'}
                    style={{ padding: '5px 0px !important' }}
                  >
                    <Panel header="About Me" key="1">
                      {/* Height Section */}
                      {/* <Form.Item label="Height(in cm)">
                        <div className={styles.height}>
                          <Form.Item name="minHeight" noStyle>
                            <Select
                              placeholder="min height"
                              style={{
                                width: '100%'
                              }}
                            >
                              {[...Array(61).keys()].map((height) => {
                                const cmHeight = height + 120;
                                return (
                                  <Select.Option
                                    key={cmHeight}
                                    value={cmHeight}
                                  >
                                    {cmHeight} cm
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                          <Form.Item name="maxHeight" noStyle>
                            <Select
                              placeholder="max height"
                              style={{ width: '100%' }}
                            >
                              {[...Array(91).keys()].map((h) => {
                                const cmHeight = h + 120;
                                return (
                                  <Select.Option
                                    key={cmHeight}
                                    value={cmHeight}
                                  >
                                    {cmHeight} cm
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </Form.Item> */}
                      <Form.Item label="Height (in cm)">
                        <div className={styles.height}>
                          <Form.Item
                            name="minHeight"
                            noStyle
                            rules={[
                              {
                                validator: (_, value) =>
                                  !value || (value >= 100 && value <= 250)
                                    ? Promise.resolve()
                                    : Promise.reject(
                                        new Error(
                                          'Min height must be between 100 and 250 cm'
                                        )
                                      )
                              }
                            ]}
                          >
                            <InputNumber
                              placeholder="Min Height"
                              min={100}
                              max={250}
                              style={{ width: '100%' }}
                              onChange={(value) => {
                                const val = value || 100;
                                setMinHeight(val); // update state if you need it elsewhere
                                const maxHeight =
                                  form.getFieldValue('maxHeight');

                                if (maxHeight < val) {
                                  form.setFieldsValue({ maxHeight: val });
                                }

                                form.validateFields(['maxHeight']);
                              }}
                            />
                          </Form.Item>
                          <Form.Item
                            name="maxHeight"
                            noStyle
                            dependencies={['minHeight']}
                            rules={[
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const minHeight = getFieldValue('minHeight');
                                  if (
                                    !minHeight ||
                                    !value ||
                                    value >= minHeight
                                  ) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    new Error(
                                      'Max height must be equal to or greater than Min height'
                                    )
                                  );
                                }
                              })
                            ]}
                          >
                            <InputNumber
                              placeholder="Max Height"
                              min={minHeight || 100}
                              max={250}
                              style={{ width: '100%' }}
                              onChange={() => {
                                form.validateFields(['maxHeight']);
                              }}
                            />
                          </Form.Item>
                        </div>
                      </Form.Item>

                      {/* Age Section */}
                      <Form.Item label="Age">
                        <div className={styles.height}>
                          <Form.Item name="minAge" noStyle>
                            <Select
                              showSearch
                              placeholder="Min. Age"
                              style={{
                                width: '100%',
                                borderColor: '#D32F2F',
                                height: '43px'
                              }}
                              className={styles.age}
                            >
                              {[...Array(83).keys()].map((age) => (
                                <Option key={age + 18} value={age + 18}>
                                  {age + 18}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item name="maxAge" noStyle>
                            <Select
                              showSearch
                              placeholder="Max. Age"
                              style={{
                                width: '100%',
                                borderColor: '#D32F2F',
                                height: '43px'
                              }}
                              className={styles.age}
                            >
                              {[...Array(83).keys()].map((age) => (
                                <Option key={age + 18} value={age + 18}>
                                  {age + 18}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Form.Item>

                      {/* Marital Status Section */}
                      <Form.Item label="Marital Status" name="maritalStatus">
                        <Checkbox.Group className={styles.grup}>
                          <div className={styles.checkBtn}>
                            <Checkbox value="Unmarried">Unmarried</Checkbox>
                            <Checkbox value="Widowed">Widowed</Checkbox>
                            <Checkbox value="Divorced">Divorced</Checkbox>
                            <Checkbox value="Awaiting_Divorced">
                              Awaiting Divorced
                            </Checkbox>
                          </div>
                        </Checkbox.Group>
                      </Form.Item>

                      {/* City Section */}
                      <Form.Item label="City" name="city">
                        <Select
                          className={styles.customSelectHob}
                          mode="multiple"
                          placeholder="Select City"
                          showSearch
                          // showArrow={true}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          onChange={(value) =>
                            form.setFieldsValue({
                              personal_city: value
                            })
                          }
                        >
                          {city_details?.map((city) => (
                            <Option value={city?.city} key={city.id}>
                              {city?.city}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {/**state */}
                      <Form.Item label="State" name="state">
                        <Select
                          mode="multiple"
                          placeholder="Select State"
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          onChange={(value) =>
                            form.setFieldsValue({
                              personal_state: value
                            })
                          }
                        >
                          {state_details?.map((state, index) => (
                            <Option value={state?.state} key={index}>
                              {state?.state}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {/* Country Section */}
                      <Form.Item label="Country" name="country">
                        <Select
                          mode="multiple"
                          placeholder="Select Country"
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          onChange={(value) =>
                            form.setFieldsValue({
                              personal_country: value
                            })
                          }
                        >
                          {country_codes?.map((code, index) => (
                            <Option value={code?.country} key={index}>
                              {code?.country}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Panel>
                    <Panel header="Family Details" key="2">
                      <Form.Item label="Mother's Education">
                        <div className={styles.height}>
                          <Form.Item name="desired_partner_mother_education">
                            <Select
                              placeholder="Select a Degree"
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              onChange={(value) =>
                                form.setFieldsValue({
                                  desired_partner_mother_education: value
                                })
                              }
                            >
                              {education_list?.length
                                ? education_list?.map((list, index) => {
                                    return (
                                      <option
                                        value={list?.higher_education}
                                        key={index}
                                      >
                                        {list?.higher_education}
                                      </option>
                                    );
                                  })
                                : ''}
                            </Select>
                          </Form.Item>
                        </div>
                      </Form.Item>
                      <Form.Item label="Father's Education">
                        <div className={styles.height}>
                          <Form.Item name="desired_partner_father_education">
                            <Select
                              placeholder="Select a Degree"
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              onChange={(value) =>
                                form.setFieldsValue({
                                  desired_partner_father_education: value
                                })
                              }
                            >
                              {education_list?.length
                                ? education_list?.map((list, index) => {
                                    return (
                                      <option
                                        value={list?.higher_education}
                                        key={index}
                                      >
                                        {list?.higher_education}
                                      </option>
                                    );
                                  })
                                : ''}
                            </Select>
                          </Form.Item>
                        </div>
                      </Form.Item>
                      <Form.Item label="Family Type" name="familyType">
                        <Checkbox.Group className={styles.grupT}>
                          <div className={styles.checkBtn}>
                            <Checkbox value="Joint">Joint</Checkbox>
                            <Checkbox value="Nuclear">Nuclear</Checkbox>
                          </div>
                        </Checkbox.Group>
                      </Form.Item>

                      <Form.Item label="Family Status" name="familyStatus">
                        <Checkbox.Group className={styles.grup}>
                          <div className={styles.checkBtn}>
                            <Checkbox value="Middle Class">
                              Middle Class
                            </Checkbox>
                            <Checkbox value="Upper-Middle Class">
                              Upper-Middle Class
                            </Checkbox>
                            <Checkbox value="High Class">High Class</Checkbox>
                            <Checkbox value="Rich/Affluent">
                              {' '}
                              Rich/Affluent
                            </Checkbox>
                          </div>
                        </Checkbox.Group>
                      </Form.Item>

                      <Form.Item label="Family Values" name="familyValues">
                        <Checkbox.Group className={styles.grup}>
                          <div className={styles.checkBtn}>
                            <Checkbox value="Orthodox">Orthodox</Checkbox>
                            <Checkbox value="Traditional">Traditional</Checkbox>
                            <Checkbox value="Moderate">Moderate</Checkbox>
                            <Checkbox value="Liberal"> Liberal</Checkbox>
                          </div>
                        </Checkbox.Group>
                      </Form.Item>
                    </Panel>

                    <Panel header="Career & Education" key="3">
                      <Form.Item label="Education" name="education">
                        <Select
                          placeholder="Select a Degree"
                          className={styles.select}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          onChange={(value) =>
                            form.setFieldsValue({
                              education: value
                            })
                          }
                        >
                          {education_list?.length
                            ? education_list?.map((list, index) => {
                                return (
                                  <option
                                    value={list?.higher_education}
                                    key={index}
                                  >
                                    {list?.higher_education}
                                  </option>
                                );
                              })
                            : ''}
                        </Select>
                      </Form.Item>

                      <Form.Item label="Employee In " name="employeeIn">
                        <Checkbox.Group className={styles.grup}>
                          <div className={styles.checkBtn}>
                            <Checkbox value="Government/PSU">
                              Government/PSU
                            </Checkbox>
                            <Checkbox value="Private">Private</Checkbox>
                            <Checkbox value="Business">Business</Checkbox>
                            <Checkbox value="Defence">Defence</Checkbox>
                            <Checkbox value="Self-Employed">
                              Self-Employed
                            </Checkbox>
                            <Checkbox value="Not Working">Not Working</Checkbox>
                          </div>
                        </Checkbox.Group>
                      </Form.Item>

                      <Form.Item label="Department / Sector" name="department">
                        <Select
                          placeholder="Select Field of Work"
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          onChange={(value) =>
                            form.setFieldsValue({ department: value })
                          }
                        >
                          {department_details?.length
                            ? department_details?.map((department, index) => {
                                return (
                                  <option
                                    value={department?.department}
                                    key={index}
                                  >
                                    {department?.department}
                                  </option>
                                );
                              })
                            : ''}
                        </Select>
                      </Form.Item>

                      {/* <Form.Item label="Annual Income" name="income">
                        <Input
                          placeholder="Income"
                          type="number"
                          style={{
                            background: '#faf1d9',
                            borderRadius: '6px',
                            border: '1px solid #d20b0b',
                            fontFamily: 'Teachers'
                          }}
                        />
                      </Form.Item> */}
                      <Form.Item
                        label="Annual Income"
                        // name="income"
                      >
                        <Row className={styles.inc}>
                          <Form.Item name="min_income">
                            <Input
                              placeholder="Min Income"
                              type="number"
                              style={{
                                background: '#faf1d9',
                                borderRadius: '6px',
                                border: '1px solid #d20b0b',
                                fontFamily: 'Teachers'
                              }}
                            />
                          </Form.Item>
                          <Form.Item name="max_income">
                            <Input
                              placeholder="Max Income"
                              type="number"
                              style={{
                                background: '#faf1d9',
                                borderRadius: '6px',
                                border: '1px solid #d20b0b',
                                fontFamily: 'Teachers'
                              }}
                            />
                          </Form.Item>
                        </Row>
                      </Form.Item>
                    </Panel>
                  </Collapse>
                  <div className={styles.btnflex}>
                    <button
                      className={styles.back}
                      onClick={handle_removeLocalStorage}
                    >
                      Clear
                    </button>
                    <button className={styles.back} onClick={handle_backButton}>
                      Back
                    </button>
                  </div>
                </Col>
              )}
            </Row>
          </Form>
        </div>
        {/* Middle containt */}
        {transformedData?.length === 0 ? (
          <Card
            className={styles.searchNoResult}
            style={{ textAlign: 'center' }}
          >
            <p>No profiles found. Please refine your search.</p>
          </Card>
        ) : (
          <div className={styles.searchResult}>
            {transformedData?.map((data, index) => (
              <div key={data.code || index} className={styles.cardOuter}>
                <div className={styles.cardOutline}>
                  <div
                    className={styles.cardInner1}
                    style={{
                      cursor: 'pointer'
                    }}
                  >
                    <img
                      src={data.pic}
                      alt={data.name}
                      className={styles.cardImage}
                    />
                    {/* {(data.isNew || data.isFavourite) && (
                      <div className={styles.cardNew}>
                        {data.isNew && 'New '}
                        {data.isFavourite && 'Favourite'}
                      </div>
                    )} */}
                    <div
                      className={styles.cardIcons}
                      onMouseEnter={() => setIsHovered(data.profile_id)}
                      onMouseLeave={() => setIsHovered(null)}
                    >
                      <div
                        onClick={(e) =>
                          handleLikeClick(e, data.profile_id, 'aiData')
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        {/* <img
                          src={
                            likedProfiles[data.profile_id] ||
                            isHovered === data.profile_id
                              ? HeartIcon
                              : HeartOut
                          }
                          alt="heart"
                        /> */}
                        <img
                          src={
                            likedProfiles[data.profile_id] ||
                            isHovered === data.profile_id
                              ? HeartIcon
                              : HeartOut
                          }
                          alt="heart"
                        />
                      </div>
                    </div>
                  </div>

                  <div className={styles.cardOuter2}>
                    <div
                      className={styles.cardInner2}
                      style={{
                        color: '#d20b0b',
                        backgroundColor: 'transparent'
                      }}
                    >
                      <span className={styles.cardInnerTitle}>
                        {data?.name}
                      </span>
                      <span className={styles.cardInnerSubTitle}>
                        {data?.code}
                      </span>
                    </div>
                    <div
                      className={styles.cardInnerDetails}
                      style={{
                        color: '#d20b0b',
                        background: 'transparent'
                      }}
                    >
                      <div className={styles.topdetails}>
                        <span className={styles.cardDetails}>
                          <UserOutlined /> {data.dob} yrs / {data.height}{' '}
                          {data.marriedStatus}
                        </span>
                        <span className={styles.cardDetails}>
                          <FaGraduationCap style={{ paddingTop: '3px' }} />{' '}
                          {data.education}
                        </span>
                        <span className={styles.cardDetails}>
                          <MdOutlineWorkOutline style={{ paddingTop: '3px' }} />{' '}
                          {data.occupation}
                        </span>

                        <span className={styles.cardDetails}>
                          <FaMoneyCheckAlt style={{ paddingTop: '3px' }} />{' '}
                          {data.income ? `Rs ${data.income}` : ''}
                        </span>
                        <span className={styles.cardDetails}>
                          <IoLocationOutline style={{ paddingTop: '3px' }} />{' '}
                          {data.address}
                        </span>
                      </div>

                      <div className={styles.searchDiv}>
                        <button
                          className={styles.searchBtn}
                          onClick={() => handleViewProfile(data.id)}
                        >
                          View Profile
                        </button>
                        {/* <button
                          className={styles.searchBtn}
                          // onClick={handleSendRequest}
                          onClick={() => handleSendRequest(data.profile_id)}
                        >
                          Send Request
                        </button> */}
                        {/* <button
                          className={styles.searchBtn}
                          onClick={() => handleSendRequest(data.profile_id)}
                        > */}
                        {/* Send Request */}
                        {/* {data.is_req_rejected
                            ? 'Un Friend'
                            : data.is_req_accepted
                            ? 'Friend'
                            : data.is_requested
                            ? 'Request Sent'
                            : 'Add Friend'} */}
                        {/* {data.is_request_received ? (
                            <div className={styles.actionButtons}>
                              <Button
                                className={styles.buttonTop}
                                onClick={() =>
                                  handleRequestAction('accept', data.profile_id)
                                }
                                disabled={data?.is_req_accepted}
                                style={{ color: '#D20B0B' }}
                              >
                                {data?.is_req_accepted ? 'Friend' : 'Accept'}
                              </Button>
                              <Button
                                className={styles.buttonTop}
                                onClick={() =>
                                  handleRequestAction('reject', data.profile_id)
                                }
                                disabled={data?.is_received_req_rejected}
                                style={{ color: '#D20B0B' }}
                              >
                                {data?.is_received_req_rejected
                                  ? 'Declined'
                                  : 'Decline'}
                              </Button>
                            </div>
                          ) : (
                            <div>
                              {data.is_req_rejected
                                ? 'Unfriend'
                                : data.is_req_accepted
                                ? 'Friend'
                                : data.is_requested
                                ? 'Request Sent'
                                : 'Add Friend'}
                            </div>
                          )} */}
                        {/* </button> */}
                        <button
                          className={styles.searchBtn}
                          // onClick={handleShortList}
                          onClick={() => handleShortList(data.profile_id)}
                          disabled={data.is_shortlisted}
                        >
                          {data.is_shortlisted
                            ? 'Shortlisted'
                            : 'Shortlist Profile'}
                          {/* Shortlist Profile */}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}{' '}
      </div>{' '}
    </>
  );
};
export default SlideBar;
